import {
    API_DOMAIN,
    AUTH_PROFILE_STORAGE_KEY,
    AUTH_RETURN_PATH_STORAGE_KEY,
    AUTH_TOKEN_STORAGE_KEY,
    AUTH_USER_STORAGE_KEY,
    DISCORD_CLIENT_ID,
    DISCORD_OAUTH_SCOPE,
    DISCORD_REDIRECT_URI,
} from "./constants";

export function getRedirectUri() {
    return DISCORD_REDIRECT_URI || window.location.origin;
}

export function getStoredToken() {
    return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
}

export function readStoredJson(key) {
    const value = localStorage.getItem(key);
    if (!value) return null;

    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
}

export function getStoredProfile() {
    return readStoredJson(AUTH_PROFILE_STORAGE_KEY);
}

export function storeProfile(profile) {
    localStorage.setItem(AUTH_PROFILE_STORAGE_KEY, JSON.stringify(profile));
    if (profile?.user) {
        localStorage.setItem(AUTH_USER_STORAGE_KEY, JSON.stringify(profile.user));
    }
}

export function persistAuthPayload(payload) {
    const profile = {
        authorized: Boolean(payload.authorized),
        is_admin: Boolean(payload.is_admin),
        user: payload.user || null,
        request: payload.request || null,
        token_type: payload.token?.token_type || null,
        requires_reauthentication: false,
    };

    if (payload.token?.access_token) {
        localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, payload.token.access_token);
    }
    storeProfile(profile);
    return profile;
}

export function clearStoredAuth() {
    localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    localStorage.removeItem(AUTH_USER_STORAGE_KEY);
    localStorage.removeItem(AUTH_PROFILE_STORAGE_KEY);
}

export function rememberReturnPath(path) {
    if (path && path !== "/") {
        sessionStorage.setItem(AUTH_RETURN_PATH_STORAGE_KEY, path);
    }
}

export function consumeReturnPath() {
    const path = sessionStorage.getItem(AUTH_RETURN_PATH_STORAGE_KEY);
    sessionStorage.removeItem(AUTH_RETURN_PATH_STORAGE_KEY);
    return path;
}

export function getDiscordAuthorizeUrl() {
    if (!DISCORD_CLIENT_ID) return null;

    const params = new URLSearchParams({
        client_id: DISCORD_CLIENT_ID,
        redirect_uri: getRedirectUri(),
        response_type: "code",
        scope: DISCORD_OAUTH_SCOPE,
    });

    return `https://discord.com/oauth2/authorize?${params.toString()}`;
}

export async function apiFetch(path, { token, method = "GET", body } = {}) {
    const headers = {};

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    if (body !== undefined) {
        headers["Content-Type"] = "application/json";
    }

    const response = await fetch(`${API_DOMAIN}${path}`, {
        method,
        headers,
        body: body === undefined ? undefined : JSON.stringify(body),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
        const error = new Error(payload.reason || payload.error || "Request failed.");
        error.status = response.status;
        error.payload = payload;
        throw error;
    }

    return payload;
}
